module.exports = __webpack_public_path__ + "img/thumbnail-hover.e2f06f6c.svg";